import { ActionCallback, ActionCallback2, ActionCallback3, EmptyCallback } from '../api';
import { adminApi } from '../api/admin';
import * as TradingView from '../charting_library';
import { AutoScaleReset } from '../config/general-config';
import { UserTheme } from '../config/misc';
import { TickerInfo } from '../config/tickers';
import { AutoScaleChangedCallback, Bias, CrossHairChangedCallback, DrawingControl, hub, hubTFData, hubTickerData, OnContextCallback, TickerChangedCallback, UpdateViewField, UpdateViewType } from '../hub';
import { SmpaTool } from '../smpa';
import { equalIC, isSet } from '../storage';
import { SyncerUpdateType, TVSyncer } from '../tv/sync';
import { BarData, TVDataFeed } from './datafeed';
import { DateTime } from './datetime';
import { TVHelper } from './helper';
export enum ThemeName {
    light = 'light',
    dark = 'dark'
}

interface IUpdateState {
    tid: string;
    tf: string;
}
export interface tvbar {
    t: number;
    o: number;
    h: number;
    l: number;
    c: number;
    v?: number;
}
export interface IDrawingInfo {
    toolbar: HTMLElement;
    canvas: HTMLElement;
    visibility: HTMLElement;
}

export interface IHubInternals {
    onInited: EmptyCallback,
    onBeginChange: OnContextCallback,
    onEndChange: OnContextCallback,
    onTickerChanged: EmptyCallback,
    onBarReplayChanged: OnContextCallback;
    onBarsReceived: ActionCallback2<string, string>,

    data: hubTickerData,
    tvInit: TradingView.DatafeedConfiguration,
    syncer: TVSyncer,

}

export enum TargetsPreview {
    No,
    AllInOne,
    Bullish,
    Bearish
}

enum SpyType {
    Ready,
    Symbol,
    Interval,
    DataLoaded,
}
class TVSpy {
    private pushes = 0;
    readyAnonced = false;
    symbolAnonced = false;
    intervalAnonced = false;
    dataLoadedAnonced = false;
    onAnonce: EmptyCallback;
    onSuspended: EmptyCallback;
    private id: number;
    constructor(id: number) {
        this.id = id;
    }

    isReady() { return this.pushes == 0; }
    get hasDataLoaded() {
        return (this.pushes & (1 << SpyType.DataLoaded)) != 0;
    }
    push(type: SpyType, internal: boolean = false) {
        if (this.pushes == 0)
            this.onSuspended();
        this.pushes |= 1 << type;
        //if (!internal)
        //    console.log(`Spy(${this.id}): push ${SpyType[type]}`);
    }
    private anonce() {
        this.onAnonce();
        this.dataLoadedAnonced = false;
        this.intervalAnonced = false;
        this.symbolAnonced = false;
        this.readyAnonced = false;
        // console.log('Spy: anonce');
    }
    pop(type: SpyType) {
        this.push(type, true);
        let checkAnnonce = false;
        if (this.pushes & (1 << type)) {
            this.pushes ^= 1 << type;
            checkAnnonce = true;
            switch (type) {
                case SpyType.Ready:
                    this.readyAnonced = true;
                    break;
                case SpyType.DataLoaded:
                    this.dataLoadedAnonced = true;
                    break;
                case SpyType.Symbol:
                    this.symbolAnonced = true;
                    break;
                case SpyType.Interval:
                    this.intervalAnonced = true;
                    break;
            }
        }
        if (checkAnnonce && !this.pushes)
            setTimeout(() => this.anonce(), 0);
    }

}
interface ViewState {
    time: TradingView.VisibleTimeRange;
    price: TradingView.VisibleTimeRange;
    autoscale: boolean;
    tvdas: boolean;
}
export class TVContext {
    private internals: IHubInternals = null;
    private userInEdit = false;
    private requestToRebuildSmpa = false;
    private crossHairBar: BarData;
    private lastTid: string;
    private lastTf: string;
    private autoScale: boolean = true;
    onResetCacheNeededCallback: EmptyCallback = null;
    onRealtimeCallback: TradingView.SubscribeBarsCallback = null;
    onTickerChanged: TickerChangedCallback = null;
    onCrossHairChanged: CrossHairChangedCallback = null;
    onBarReplayChanged: OnContextCallback = null;
    //onVisibleRanageChanged: VisibleRangeChangedCallback = null;
    onAutoScaleChanged: AutoScaleChangedCallback = null;
    get drawingVisible() {
        return !this.autoScale || hub.config.general.viewPort.autoScaleReset == AutoScaleReset.Never;
    }

    get isAutoScale() { return this.autoScale; }

    targetsPreview = TargetsPreview.No;
    bias: Bias;
    barsInfo: hubTFData;
    id: number = null;
    tv: TradingView.IChartingLibraryWidget = null;
    smpa: SmpaTool;
    shapesCache = new Map<string, { id: TradingView.EntityId, shape: TradingView.ILineDataSourceApi }[]>();
    iframe: HTMLIFrameElement = null;
    htmlHost: HTMLElement;
    private spy: TVSpy;

    drawing: IDrawingInfo = {
        toolbar: null,
        visibility: null,
        canvas: null
    };

    dataFeed: TVDataFeed;

    constructor(id: number, internals: IHubInternals) {
        this.bias = Bias.Both;
        this.internals = internals;
        this.internals.onBarsReceived = (tid, tf) => this.onBarsReceived(tid, tf);
        this.targetsPreview = TargetsPreview.No;
        this.id = id;
        this.dataFeed = new TVDataFeed(this, this.internals);
        this.spy = new TVSpy(this.id);
    }

    dispose() {
        this.clear();
        if (this.isTvReady())
            this.tv.activeChart()?.removeAllShapes();
        this.shapesCache = null;
        this.tv?.remove();
    }
    resetCache() {
        if (this.onResetCacheNeededCallback) {
            this.onResetCacheNeededCallback();
            this.tv.activeChart().resetData();
            console.log('requested new bars');
        }
    }
    getTickerInfo(): TickerInfo {
        const t = hub.getTickersData().getTicker(this.tid);
        if (t?.tickerInfo)
            return t.tickerInfo;
        return hub.tickers.get(this.tid);
    }
    setCrossHairBar(bar: BarData) {
        this.crossHairBar = bar;
        if (this.onCrossHairChanged)
            this.onCrossHairChanged(this, bar);
    }
    getCrossHairBar() {
        return this.crossHairBar;
    }
    getTimeFrameInfo() {
        return hub.tfs.get(this.tf);
    }
    get tid() {
        if (hub.isUpdating() && !hub.isSettingTicker())
            return this.lastTid;
        if (!this.isTvReady())
            return this.lastTid;
        return this.tv.activeChart().symbol();
    }
    get tf() {
        if (hub.isUpdating() && !hub.isSettingTicker())
            return this.lastTf;
        if (!this.isTvReady())
            return this.lastTf;
        return this.tv.activeChart().resolution();
    }

    convertToUtc(seconds: number) {
        const tz = this.tv.activeChart().getTimezoneApi().getTimezone();
        if (!tz.offset)
            return seconds;
        return DateTime.convertToUTC(seconds, tz.id);
    }

    convertFromUtc(seconds: number) {
        const tz = this.tv.activeChart().getTimezoneApi().getTimezone();
        if (!tz.offset)
            return seconds;
        return DateTime.convertFromUTC(seconds, tz.id);
    }

    private initDrawing() {
        if (this.fillDrawing())
            return;
        setTimeout(() => this.initDrawing(), 5);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setTV(tv: TradingView.IChartingLibraryWidget, tid: string, tf: string) {
        this.lastTf = tf;
        this.lastTid = tid;
        this.tv = tv;
        this.iframe = this.htmlHost.childNodes[0] as HTMLIFrameElement;
        this.iframe.addEventListener("load", () => this.initDrawing());

        this.spy.onSuspended = () => {
            this.internals.onBeginChange(this);
        }
        this.spy.onAnonce = () => {

            // if (this.barsInfo == null)
            this.barsInfo = this.internals.data.getBars(this.tid, this.tf);
            if (this.spy.readyAnonced) {
                this.fillDrawing();
                this.updateView(UpdateViewType.TV | UpdateViewType.General, true);
                this.internals.onInited();
                //this.tv.onContextMenu((unixtime: number, price: number) => {
                //    return [{
                //        position: "top",
                //        text: "First top menu item, time: " + unixtime + ", price: " + price,
                //        click: () => { alert("First clicked."); }
                //    }];
                //});
                //this.tv.activeChart().createStudy('volume', true, false, null, null, {
                //    allowChangeCurrency: false,
                //    disableUndo: true
                //});
            }
            this.updateTVSmpa();
            if (this.spy.symbolAnonced)
                this.internals.onTickerChanged();
            if (this.spy.readyAnonced)
                this.internals.syncer.endChange(this, SyncerUpdateType.Init);
            else if (this.spy.intervalAnonced || this.spy.symbolAnonced)
                this.internals.syncer.endChange(this, SyncerUpdateType.Symbol);
            else
                this.internals.syncer.endChange(this, SyncerUpdateType.Data);
            this.onTickerChanged(this, this.spy.readyAnonced);
            this.internals.onEndChange(this);
        }
        this.spy.symbolAnonced = true;
        this.spy.intervalAnonced = true;
        this.spy.push(SpyType.Ready);
        this.spy.push(SpyType.DataLoaded);
        this.tv.onChartReady(() => {
            if (this.tv.watermark().visibility().value())
                this.tv.watermark().visibility().setValue(false, true);
            this.setNonOverrides();
            this.subscribeToTV();
            this.spy.pop(SpyType.Ready);
        });
    }
    public takeScreenshot() {
        if (hub.config.chart.tv.watermark.on)
            this.tv.watermark().visibility().setValue(true, true);
        else
            setTimeout(() => this.tv.takeScreenshot())
    }
    private subscribeToTV() {
        this.tv.subscribe("onScreenshotReady", (url: string) => {
            if (hub.onScreenshotReady)
                hub.onScreenshotReady('https://www.tradingview.com/x/' + url + '/');
            this.tv.watermark().visibility().setValue(false, false);
        });
        this.tv.watermark().visibility().subscribe((v: boolean) => {
            if (v)
                setTimeout(() => this.tv.takeScreenshot())
        });

        this.tv.activeChart().onSymbolChanged().subscribe(null, () => this.spy.pop(SpyType.Symbol));
        this.tv.activeChart().onDataLoaded().subscribe(null, () => this.spy.pop(SpyType.DataLoaded));
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.tv.activeChart().onIntervalChanged().subscribe(null, () => this.spy.pop(SpyType.Interval));
        this.tv.subscribe("onSelectedLineToolChanged", () => {
            const tools = this.tv.selectedLineTool();
            if (this.isSelectionTool(tools))
                this.endUserEdit();
            else if (!this.isFreeFormTool(tools))
                this.beginUserEdit();
        });
        this.tv.subscribe("mouse_down", () => {
            if (this.isFreeFormTool(this.tv.selectedLineTool()))
                this.beginUserEdit();
        });
        this.tv.subscribe("mouse_up", () => {
            if (this.isFreeFormTool(this.tv.selectedLineTool()))
                this.endUserEdit();
        });
    }
    private isSelectionTool(tool: TradingView.SupportedLineTools) {
        switch (tool) {
            case 'cursor':
            case 'dot':
            case 'arrow_cursor':
            case 'eraser':
                return true;
        }
        return false;
    }
    private isFreeFormTool(tool: TradingView.SupportedLineTools) {
        switch (tool) {
            case 'brush':
            case 'highlighter':
                return true;
        }
        return false;
    }
    setTicker(tid: string, tf: string) {
        this.lastTid = tid;
        this.lastTf = tf;
        const setTicker = this.tv.activeChart().symbol() != tid;
        const setInterval = this.tv.activeChart().resolution() != tf;

        hub.cache.preload(tid);

        if (setTicker || setInterval)
            this.internals.syncer.beforeChange(this, SyncerUpdateType.Symbol);

        if (setTicker)
            this.spy.push(SpyType.Symbol);
        if (setInterval)
            this.spy.push(SpyType.Interval);
        if (setTicker || setInterval) {
            this.spy.push(SpyType.DataLoaded);
            this.barsInfo = null;
            this.smpa?.clear();
        }
        if (setTicker)
            this.tv.activeChart().setSymbol(tid);
        if (setInterval)
            this.tv.activeChart().setResolution(tf as TradingView.ResolutionString);
    }

    setAutoScale(tv: boolean, autoScale: boolean) {
        if (this.autoScale == autoScale) {
            this.fitView();
            return;
        }
        this.autoScale = autoScale;
        if (this.onAutoScaleChanged)
            this.onAutoScaleChanged(this, tv);

        this.fitView();
    }

    setTargetsPreview(type: TargetsPreview) {
        this.targetsPreview = type;
        if (this.smpa)
            this.smpa.updateView(false);
    }
    setBias(bias: Bias) {
        this.bias = bias;
        if (this.smpa)
            this.smpa.updateView(false);
    }
    isIdle() {
        return this.spy.isReady();
    }
    clear() {
        this.barsInfo = null;
        this.targetsPreview = TargetsPreview.No;
        this.smpa?.clear();
    }
    isTvReady() {
        const window = (this.tv as any)?._innerWindow();
        if (!window)
            return false;
        if (!window.tradingViewApi)
            return false;
        return true;
    }


    private setDrawingVisibilityInternal(visible: boolean) {
        if (this.tv.activeChart().getCheckableActionState('drawingToolbarAction') == visible)
            return;
        this.drawing?.visibility?.click();
    }

    getDrawingToolbarWidth() {
        return this.drawing.toolbar ? this.drawing.toolbar.clientWidth : 0;
    }

    private fillDrawing(): boolean {
        if (this.drawing.visibility)
            return true;
        const doc = this.iframe.contentWindow.document;
        this.setBackgroundColor();
        let elems = doc.querySelectorAll('div[class^="layout__area--left"]');
        if (elems.length == 0)
            return false;
        this.drawing.toolbar = elems[0] as HTMLElement;

        elems = doc.querySelectorAll('div[class^="chart-gui-wrapper"]');
        this.drawing.canvas = elems[0] as HTMLElement;

        const valsElem = this.drawing.toolbar.querySelectorAll('div[class^="toggleButton-"]');
        if (valsElem.length == 0)
            return false;
        this.drawing.visibility = valsElem[0] as HTMLElement;
        if (hub.options.drawingControl == DrawingControl.Disabled)
            return true;
        this.drawing.visibility.style.display = 'none';
        this.refreshDrawingVisibility();
        return true;
    }

    private refreshDrawingVisibility() {
        if (hub.options.drawingControl == DrawingControl.Disabled)
            return;
        if (!this.drawing.toolbar || !this.isTvReady())
            return;
        this.setDrawingVisibilityInternal(this.drawingVisible);
    }

    getTime(bar = 0) {
        const bars = this.bars;
        if (bars.length == 0 || bar < 0)
            return 0;
        if (bar >= bars.length)
            return bars[0].t;
        return bars[bars.length - 1 - bar].t;
    }
    getBar(bar = 0) {
        const bars = this.bars;
        if (bars.length == 0 || bar < 0)
            return null;
        if (bar >= bars.length)
            return bars[bars.length - 1];
        return bars[bars.length - 1 - bar];
    }
    getBarByTime(ts: number) {
        const bar = this.getBarIdx(ts);
        if (bar < 0)
            return null;
        return this.bars[bar];
    }
    getBarIdx(ts: number) {
        const t = ts * 1000;
        const bars = this.bars;
        for (let i = bars.length - 1; i >= 0; i--)
            if (t >= bars[i].t)
                return i;
        return -1;
    }

    getBarByIdx(idx: number) {
        const bars = this.bars;
        if (bars.length > 0) {
            if (idx < 0)
                return bars[0];
            return bars[Math.min(bars.length - 1, idx)];
        }
        return null;
    }
    getDataBarIdx(ts: number) {
        const t = ts * 1000;
        const bars = this.bars;
        if (this.barsInfo)
            for (let i = bars.length - 1; i >= 0; i--)
                if (t >= bars[i].t)
                    return this.barsInfo.startBar - ((bars.length - 1) - i);
        return -1;
    }
    private createBar = (v: tvbar): BarData => {
        return { t: v.t, time: v.t, open: v.o, high: v.h, low: v.l, close: v.c, volume: v.v };
    }
    addTVBars(bars: tvbar[]): boolean {
        if (bars.length == 0)
            return false;
        const item = this.internals.data.getBars(this.tid, this.tf);
        if (this.lastRecord != bars[0].t)
            return false;
        let first = true;
        for (const v of bars) {
            const bar = this.createBar(v);
            this.onRealtimeCallback(bar);
            if (first) {
                first = false;
            }
            else {
                item.startBar++;
            }
        }
        return true;
    }
    get bars() {
        const bars = this.getCachedBars(this.tid, this.tf);
        return bars;
    }
    get lastRecord() {
        const bars = this.bars;
        if (bars.length == 0)
            return null;
        return bars[bars.length - 1].t;
    }
    private static emptyArr: BarData[] = [];
    getCachedBars(tid: string, tf: string): BarData[] {
        const _threads = (this.tv as any)._innerWindow()?.ChartApiInstance?._studyEngine?._cachedDatafeed?._threads;
        if (_threads == null)
            return TVContext.emptyArr;
        const name = tid + '_#_' + tf;
        const thread = _threads[name];
        if (thread == null)
            return TVContext.emptyArr;
        const bars = thread._cache?.bars as BarData[];
        return bars ?? TVContext.emptyArr;
    }
    onBarsReceived(tid: string, tf: string) {
        setTimeout(() => {
            if (this.spy.hasDataLoaded && this.tf == tf && this.tid == tid) {
                console.log(`bars: ${this.id},${tid},${tf}`);
                this.spy.pop(SpyType.DataLoaded);
            }
        }, 100);

    }
    updateTVBars() {
        const tid = this.tid;
        const tf = this.tf;
        const item = this.internals.data.getBars(tid, tf);
        let bars = this.bars;
        if (item?.rt == null)
            return;

        if (this.barsInfo != item)
            return;

        if (bars.length == 0) {
            if (this.isIdle())
                this.resetCache();
            return;
        }
        let v = item.rt.l[0];
        let reset = true;
        //const bars = this.bars;
        const t0 = bars == null ? 0 : bars[bars.length - 1].t;
        if (t0 == v.t) {
            const bar = this.createBar(v);
            this.onRealtimeCallback(bar);
            item.startBar++;
            reset = false;
        }
        v = item.rt.l[1];
        if (t0 == v.t || t0 < v.t && !reset) {
            const bar = this.createBar(v);
            this.onRealtimeCallback(bar);
            reset = false;
        }

        if (reset)
            this.resetCache();
    }

    updateTVSmpa() {
        if (!this.isTvReady() || !this.spy.isReady())
            return;
        if (this.smpa == null)
            return;

        setTimeout(() => {
            if (this.userInEdit) {
                this.requestToRebuildSmpa = true;
                return;
            }
            this.requestToRebuildSmpa = false;
            if (this.barsInfo == null)
                return;

            const smpaData = this.internals.data.getTicker(this.tid).smpa;
            this.smpa.buildFrom(this.tf, smpaData);

        }, 100);
    }

    private fitView() {
        if (!this.isTvReady() || !this.smpa)
            return;
        this.refreshDrawingVisibility();
        const priceScale = this.tv.activeChart().getPanes()[0].getMainSourcePriceScale();
        if (this.autoScale) {
            const viewPortConfig = hub.config.general.viewPort;
            let clientWidth = this.drawing.canvas?.clientWidth;
            if (!clientWidth)
                clientWidth = this.iframe.offsetLeft + this.iframe.clientWidth;

            const ratio: number = clientWidth / window.innerWidth;
            const bars = Math.floor(ratio * viewPortConfig.fitBars);
            const from = Math.floor(this.getTime(bars) / 1000);
            const mr = Math.floor(viewPortConfig.margin.r);
            try {
                this.tv.activeChart().setVisibleRange({
                    from: from
                }, {
                    applyDefaultRightMargin: false,
                    percentRightMargin: mr
                }).then(() => {
                    if (!priceScale.isAutoScale())
                        priceScale.setAutoScale(true);
                }).catch(e => {
                    console.warn(this.id + '.setVisibleRange:' + e.message);
                });
            } catch (e) {
                console.error(e);
            }
        } else {
            if (priceScale.isAutoScale())
                priceScale.setAutoScale(false);
        }
    }

    beginUserEdit() {
        if (this.userInEdit)
            return;
        this.userInEdit = true;
        // console.log('begin user edit mode: ' + this.tv.selectedLineTool());
    }

    endUserEdit() {
        if (!this.userInEdit)
            return;
        this.userInEdit = false;
        //   console.log('end user edit mode');
        if (this.requestToRebuildSmpa)
            this.updateTVSmpa();
    }

    private setBackgroundColor() {
        if (this.iframe == null)
            return;
        this.iframe.contentDocument.documentElement.style.backgroundColor = hub.tvConfig.paneProperties.background;
        this.iframe.contentDocument.body.style.backgroundColor = hub.tvConfig.paneProperties.background;

    }
    private setNonOverrides() {
        this.tv.dateFormat().setValue(hub.config.general.dateFormat as TradingView.DateFormat);
        this.tv.timeHoursFormat().setValue(hub.config.general.timeHoursFormat as TradingView.TimeHoursFormat);
        this.tv.watermark().color().setValue(hub.config.chart.tv.watermark.col);
        this.setBackgroundColor();
    }

    updateView(type: UpdateViewType, init = false, field = UpdateViewField.Some) {
        if (equalIC(this.tv.getTheme(), ThemeName.dark) != (hub.tvtheme == UserTheme.Dark)) {
            let themeName: TradingView.ThemeName = ThemeName.dark;
            if (hub.tvtheme == UserTheme.Light)
                themeName = ThemeName.light;
            this.tv.changeTheme(themeName).then(() => {
                this.tv.applyOverrides(TVHelper.overrides());
                this.setNonOverrides();
            });
        } else if (isSet(type, UpdateViewType.TV)) {
            this.tv.applyOverrides(TVHelper.overrides());
            this.setNonOverrides();
        }

        if (this.smpa) {
            if (isSet(type, UpdateViewType.Smpa))
                this.smpa.updateView(init, field);
            if (isSet(type, UpdateViewType.General))
                this.fitView();

        }

        this.internals.syncer.updateView(this, init, type, field);
    }

    setReplayMode = (on: boolean) => {
        if (!on) {
            adminApi.barReplay(this.tid, this.tf, null, 0, false).then(s => {
                hub.getTickersData().setReplayMode(this.tid, false);
                this.internals.onBarReplayChanged(this);
                if (this.onBarReplayChanged)
                    this.onBarReplayChanged(this);
            });
        } else
            this.internals.syncer.items[this.id].barReplay.activate(() => {
                hub.getTickersData().setReplayMode(this.tid, true);
                this.internals.onBarReplayChanged(this);
                if (this.onBarReplayChanged)
                    this.onBarReplayChanged(this);
            });
    }

    pingSMPA() {
        let bar: number = null;
        const barReplay = this.internals.syncer.items[this.id].barReplay;
        adminApi.pingSMPA(bar, this);
    }

    pickFixBar(at: number, onTime: ActionCallback2<TVContext, number>) {
        const fixData = this.internals.syncer.items[this.id].fixData;
        fixData?.activate(at, onTime);
    }
    hideFixBar() {
        const fixData = this.internals.syncer.items[this.id].fixData;
        fixData?.deactivate();
    }

    showDayK(dev: number, eq: number, cas: number, changed: ActionCallback3<TVContext, number, number>) {
        const tool = this.internals.syncer.items[this.id].dayk;
        tool?.activate(dev, eq, cas, changed);
    }
    hideDayK() {
        const tool = this.internals.syncer.items[this.id].dayk;
        tool?.deactivate();
    }
}
